// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".signup-with-google-btn[data-v-5ee8c49e]{display:inline-block;font-size:14px;font-family:Roboto;color:#fff;font-weight:500;background:#4285f4;box-shadow:0 1px 1px rgba(0,0,0,.24),0 0 1px rgba(0,0,0,.12);border-radius:2px;background-color:#00f;cursor:pointer}.signup-with-google-btn[data-v-5ee8c49e]:hover{box-shadow:0 3px 6px rgba(0,0,0,.16)}.google-logo[data-v-5ee8c49e]{vertical-align:middle}.negative-margin12[data-v-5ee8c49e]{margin-top:-12px;display:block}", ""]);
// Exports
module.exports = exports;
